import React from 'react'
import { useParams, useLocation, Redirect } from 'react-router-dom'

import { useGetArtboardBySlugQuery } from 'gqlTypes'
import LoadingState from 'components/LoadingState'
import PageLayout from 'layouts/PageLayout'
import EmptyHeader from 'containers/EmptyHeader'
import { useToast } from 'containers/ToastManager'
import { RouteParams } from 'constants/routes'

const ArtboardSlugRedirect = () => {
  const { showToast } = useToast()

  const { shareID, pageSlug, artboardSlug } = useParams<
    RouteParams<'LEGACY_ARTBOARD_SLUG'>
  >()
  const { pathname } = useLocation()

  const { data, loading, error } = useGetArtboardBySlugQuery({
    variables: {
      shareIdentifier: shareID,
      pageSlug,
      artboardSlug,
    },
  })

  if (loading)
    return (
      <PageLayout header={EmptyHeader}>
        <LoadingState />
      </PageLayout>
    )

  if (error) return <Redirect to={`/s/${shareID}`} />

  const artboardShortId =
    data?.share?.version?.document?.page?.artboard?.shortId

  if (!artboardShortId) {
    showToast('Artboard could not be found', 'negative')
    return <Redirect to={`/s/${shareID}`} />
  }

  if (pathname.includes('/play'))
    return <Redirect to={`/s/${shareID}/${artboardShortId}/play`} />

  return <Redirect to={`/s/${shareID}/${artboardShortId}`} />
}

export default ArtboardSlugRedirect
